export default "__VITE_ASSET__cSKSYtrX__"